import { TitleAlign } from '@api/selections';
import { EpiBlock } from '@api/types';
import { BlockContainer, BlockProperty, CategoryCard, ContentItemLoader, Title } from '@components';
import { Box, Grid } from '@mui/material';
import React from 'react';

// TYPES
//-------
type CategoryListBlockProps = {
  title?: string;
  children?: React.ReactNode;
  content?: EpiBlock[];
  titleAlign?: TitleAlign;
};

// COMPONENTS
//------------
export const CategoryListBlock = ({
  title,
  children,
  content = [],
  titleAlign,
}: CategoryListBlockProps) => {
  return (
    <BlockContainer>
      <BlockProperty property='title'>
        <Box sx={{ mb: 4, display: 'block' }}>
          <Title variant='h2' className='main-title' sx={{ textAlign: titleAlign || 'center' }}>
            {title}
          </Title>
        </Box>
      </BlockProperty>
      <BlockProperty property='content'>
        <Grid container spacing={{ xs: 1, sm: 2 }}>
          {content?.map &&
            content?.map((item, index) => {
              const guid = item?.contentLink?.guidValue;
              return (
                <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
                  <ContentItemLoader guid={guid} component={CategoryCard} />
                </Grid>
              );
            })}
          {children}
        </Grid>
      </BlockProperty>
    </BlockContainer>
  );
};
